import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { TabItem } from '../VerticalTabs/VerticalTabs.types';

interface ScrollableHorizonalTabsProps {
  items: TabItem[];
  selectedItemIndex: number;
  onClick: (index: number) => void;
}

export const HorizonalTabs: React.FC<ScrollableHorizonalTabsProps> = ({ items, selectedItemIndex, onClick }) => {
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    onClick(newValue);
  };

  return (
    <Box
      sx={{
        maxWidth: { xs: 480, sm: 780, marginLeft: -20, paddingLeft: 0 },
        bgcolor: 'background.paper',
        height: 30,
      }}
    >
      <Tabs
        sx={{
          '& .MuiTabs-flexContainer': {
            width: '100%',
          },
          '& .MuiTab-root': {
            color: '#2C2D3E',
            whiteSpace: 'nowrap',
            fontWeight: 600,
            size: 18,
            borderTop: '1px solid rgba(44, 45, 62, 0.3)',
            borderBottom: '1px solid rgba(44, 45, 62, 0.3)',
            borderRight: '1px solid rgba(44, 45, 62, 0.3)',
            minHeight: 'auto',
            maxHeight: '30px',
            padding: 1,
            marginTop: 1,
            width: 140,
          },
          '& .MuiButtonBase-root .MuiTab-root': {
            width: 130,
          },
          '& .MuiTabs-indicator': {
            display: 'none',
          },
          '& .Mui-selected': {
            color: 'rgb(60, 65, 154) !important',
            background: '#D6D6FB',
          },
        }}
        value={selectedItemIndex}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
        aria-label="Poziome zakładki"
      >
        {items.map((item, index) => {
          const isFirst = index === 0;
          const isLast = index === items.length - 1;
          const style = isFirst
            ? {
                borderTopLeftRadius: '5px',
                borderBottomLeftRadius: '5px',
                borderLeft: '1px solid rgba(44, 45, 62, 0.3)',
              }
            : isLast
            ? {
                borderTopRightRadius: '5px',
                borderBottomRightRadius: '5px',
              }
            : {};
          const labelText = item.label
            ? item.label.length > 20
              ? item.label.substring(0, 16) + '...'
              : item.label
            : '';
          return <Tab disableRipple style={style} wrapped key={`tab-${item.label}-${index}`} label={labelText} />;
        })}
      </Tabs>
    </Box>
  );
};
